import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { NzResizeEvent } from "ng-zorro-antd/resizable";
import { DOCUMENT } from "@angular/common";
import { CommonService } from "src/@services/common.service";
import { FormService } from "src/@services/form.service";
import { BrowserPlatformService } from "src/@services/browser-platform.service";
import { InnerPagesService } from "src/app/pages/common-layout/inner-pages.service";
import { responseMessageStatus, ResponseStatus } from "../../enum";
import { CdkDragDrop } from "@angular/cdk/drag-drop";
import { ColumnsHeader, TableId } from "src/models/commomnModel.model";

interface siteDetails {
  Name: string;
  Profile: string;
  NonAlcStatus: boolean;
  IsTagVisible: boolean;
  IsProgramPeriodVisible: boolean;
  Date?: string;
}
@Component({
  selector: "app-manage-tags",
  templateUrl: "./manage-tags.component.html",
  styleUrls: ["./manage-tags.component.scss"],
  standalone: false,
})
export class ManageTagsComponent implements OnInit {
  //#region properties
  searchText: string = "";
  pageNumber: number = 1;
  pageRecord: number = 100;
  sortBy: string = "asc";
  sortField: string = "Name";
  totalRecords: number = 0;
  isDataLoaded = false;
  isVisibleTagGroup: boolean = false;
  isVisibleTag: boolean = false;
  tags: any[] = [];
  canAddTag: boolean = false;
  canEditTag: boolean = false;
  canDeleteTag: boolean = false;
  invalidtagname: boolean = false;
  deleteConfirmVisible: boolean = false;
  isEnableButton: boolean = false;
  siteId: string;
  selectedTagData: any;
  parentTagGroupId: string = "";
  selectedTagGroupData: any;
  isTagGroupAdded: boolean = false;
  isLoadingTag: boolean = false;
  isDeletingTag: boolean = false;
  groupTitle: string = "Add Tag Group";
  tagTitle: string = "Add Tag";
  tagname: string = "";
  selectedTagGroup: any;
  selectedData: any;
  timer = null;
  oldSearchText: string = "";
  expandSet = new Set<number>();
  tagGroupData: any[] = [""];
  listOfGroups: any[] = [];
  siteDetails: siteDetails
  @ViewChild("nzTable", { static: false })
  nzTable: TableId;
  defaultColors: object[] = [
    { color: "#0077C5", class: "blue" },
    { color: "#00A6A4", class: "persianGreen" },
    { color: "#2CA01C", class: "green" },
    { color: "#6B6C72", class: "dolphin" },
    { color: "#34BFFF", class: "lightBlue" },
    { color: "#00D7D7", class: "darkTurquoise" },
    { color: "#A9E838", class: "parrotGreen" },
    { color: "#BABEC5", class: "violet" },
    { color: "#A898FF", class: "Melrose" },
    { color: "#FF88EC", class: "pink" },
    { color: "#FF8979", class: "vividTangerine" },
    { color: "#FFBB00", class: "orange" },
    { color: "#6436AF", class: "purple" },
    { color: "#C9007A", class: "magenta" },
    { color: "#D52B1E", class: "maroon" },
    { color: "#FFAC61", class: "peach" },
  ];
  show = false;
  heading: string = "";
  color: string = "";
  @Input() isFromPayments: any;
  @Output() newCreatedTag = new EventEmitter();
  isLoadingTagUpdate: boolean = false;
  cols: ColumnsHeader[] = [
    {
      title: "",
      width: "100px",
      sortDir: null,
    },
    {
      title: "Name",
      width: "700",
      sortTitle: "Name",
      sortDir: null,
    },
    {
      title: "Transactions",
      width: "300",
      sortDir: null,
    },
    {
      title: "Action",
      width: "150px",
      sortDir: null,
    },
  ];
  currentUrl: string = ''
  //#endregion

  //constructor
  constructor(
    public _cS: CommonService,
    private _iS: InnerPagesService,
    public _fS: FormService,
    private route: ActivatedRoute,
    private cdref: ChangeDetectorRef,
    private _router: Router,
    private browserPlatformService: BrowserPlatformService,
    @Inject(DOCUMENT) private doc: Document
  ) {
    _fS.tagsGroupForm_fb();
    _fS.tagForm_fb();
  }

  //#region functions
  ngOnInit(): void {
    // get permission details of current user role of users
    const tagPermissions = this._iS.canAccessTags();
    this.canAddTag = tagPermissions.canAddTag;
    this.canEditTag = tagPermissions.canEditTag;
    this.canDeleteTag = tagPermissions.canDeleteTag;

    this.currentUrl = this._router.url;
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
    //get site id for URL
    this.siteId = this.route.snapshot.paramMap.get("siteId");

    this._cS.agencySiteDetails.subscribe((res: siteDetails) => {
      if (res) {
        this.siteDetails = res;
        if (!this.siteDetails.IsTagVisible && this.currentUrl.includes('tags')) {
          this._router.navigate(['/page-not-found'])
        }
      }
    })
    this.getAllTags();
  }
  onResize({ width }: NzResizeEvent, col: string): void {
    this.cols = this.cols.map((e) =>
      e.title === col ? { ...e, width: `${width}px` } : e
    );
  }
  onExpandChange(id: number, checked: boolean): void {
    if (checked) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }
  }

  public toggleColors() {
    this.show = !this.show;
  }

  public changeColor(paint: any) {
    this.color = paint.color;
    this.show = false;
  }

  public changeColorManual(color: string) {
    const isValid = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);

    if (isValid) {
      this.color = color;
    }
  }

  //pagination
  onQueryParamsChange(event: any) {
    this.pageNumber = event;
    this.getAllTags();
    this.nzTable.elementRef.nativeElement
      .getElementsByClassName("ant-table-body")[0]
      .scrollTo(0, 0);
  }
  drop(event: CdkDragDrop<string[]>): void {
    this.moveItemInArrayIfAllowed(
      this.tagGroupData,
      event.previousIndex,
      event.currentIndex
    );
  }
  canDrop() {
    return this.tagGroupData && this.tagGroupData.length > 0;
  }
  private moveItemInArrayIfAllowed(
    array: any[],
    fromIndex: number,
    toIndex: number
  ): void {
    const from = this.clamp(fromIndex, array.length - 1);
    const to = this.clamp(toIndex, array.length - 1);

    if (from === to) {
      return;
    }

    const target = array[from];
    const delta = to < from ? -1 : 1;

    const affectedItems = array.filter((item, index) =>
      delta > 0 ? index >= from && index <= to : index >= to && index <= from
    );

    if (affectedItems.some((i) => i.isDefault)) {
      return;
    }

    for (let i = from; i !== to; i += delta) {
      array[i] = array[i + delta];
    }

    array[to] = target;
  }

  private clamp(value: number, max: number): number {
    return Math.max(0, Math.min(max, value));
  }

  /**
   * Predicate function that only allows even numbers to be
   * sorted into even indices and odd numbers at odd indices.
   */

  sortPredicateForDisableItem(items: any) {
    return function (index: number) {
      return items[index].isDefault == false;
    };
  }
  //sorting
  sort(index: any, key: any, event: any) {
    if (key) {
      this.sortBy = event == "descend" ? "desc" : "asc";
      this.sortField = event ? key : "Name";
      this.cols.forEach((element) => {
        element.sortDir = null;
      });
      this.cols[index].sortDir = event;
      this.pageNumber = 1;
      this.getAllTags();
    }
  }

  sortTags(tagGroupData: any, index: any, sortOrder: any) {
    if (sortOrder == "desc")
      tagGroupData.sort((a: any, b: any) =>
        a["name"] < b["name"] ? 1 : b["name"] < a["name"] ? -1 : 0
      );
    if (sortOrder == "asc")
      tagGroupData.sort((a: any, b: any) =>
        a["name"] > b["name"] ? 1 : b["name"] > a["name"] ? -1 : 0
      );
    this.tagGroupData[index].tags = [...tagGroupData];
    this.tagGroupData[index].sortOrder = sortOrder;
  }

  //get all tags with tag groups
  getAllTags() {
    this.isDataLoaded = true;
    const requestBody = {
      searchText: this.searchText.trim(),
      sortField: this.sortField,
      sortBy: this.sortBy,
      page: this.pageNumber,
      pageSize: this.pageRecord,
      siteId: this.siteId,
    };
    this._iS.getAllTags(requestBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.isDataLoaded = false;
        this.tagGroupData = response.result.records;
        this.totalRecords = response.result.totalRecord;
        this.tagGroupData.forEach((element) => {
          element.sortOrder = null;
        });
      } else {
        this.isDataLoaded = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }

  //on click save after on adding tag group name and color
  addTagGroup() {
    if (this._fS.tagsGroupForm.valid) {
      this.isLoadingTag = true;
      this.handleOk(true);
    } else {
      Object.values(this._fS.tagsGroupForm.controls).forEach((control: any) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }
  // add all tags in temp array
  addTagstoGroup() {
    if (!/.*\S.*/.test(this.tagname)) {
      this.invalidtagname = true;
    } else {
      this.invalidtagname = false;
      this.handleOk();
    }
  }

  // on click new tag group to show modal
  VisibleTagGroup(data: any) {
    this.isVisibleTagGroup = true;
    this.invalidtagname = false;
    this.isTagGroupAdded = false;
    this.show = false;
    this.tags = [];
    this._fS.tagsGroupForm.reset();
    this.color = "#0077C5";
    this.selectedTagGroupData = data;
    if (this.selectedTagGroupData != null) {
      this.isEnableButton = true;
      this.groupTitle = "Edit Tag Group";
      this._fS.tagsGroupForm.patchValue({
        tagGroupName: this.selectedTagGroupData.name,
      });
      this.color = this.selectedTagGroupData.color;
      this.tags = JSON.parse(JSON.stringify(this.selectedTagGroupData.tags));
      this.doc.documentElement.style.setProperty(
        "--tag-group-color",
        this.color
      );
    } else {
      this.groupTitle = "Add Tag Group";
    }
  }

  //on click x to remove item from temp tags array
  removeTag(index: any) {
    this.tags?.splice(index, 1);
  }
  //search user
  searchTag(event: any) {
    if (
      event.which != 9 &&
      event.which != 18 &&
      event.which != 13 &&
      event.which != 16 &&
      event.which != 27
    ) {
      clearTimeout(this.timer);
      if (this.searchText) {
        this.timer = setTimeout(() => {
          this.pageNumber = 1;
          this.getAllTags();
        }, 1000);
      } else {
        if (this.searchText == "") {
          this.oldSearchText = "";
          this.getAllTags();
        }
      }
    }
  }

  checkTagGroupData(event: any) {
    this.selectedTagGroup = this.listOfGroups.find((x: any) => x._id == event);
  }
  getFormData(event: any) {
    this.selectedTagGroup = event;
  }
  // on click add of tag group modal to add new group
  handleOk(isSaveClicked?: boolean): void {
    if (this._fS.tagsGroupForm.valid) {
      const formvalue = this._fS.tagsGroupForm.value;
      let tagsArrayToPass: any[] = [];
      if (this.tagname != "") {
        tagsArrayToPass = this.tags.concat([
          {
            id: "",
            name: this.tagname,
          },
        ]);
      } else {
        tagsArrayToPass = this.tags;
      }
      const tagGroupBody = {
        name: formvalue.tagGroupName,
        siteId: this.siteId,
        color: this.color,
        tags: tagsArrayToPass,
        id:
          this.selectedTagGroupData == null ? "" : this.selectedTagGroupData.id,
      };
      this.selectedTagGroupData == null
        ? this.createNewTagGroup(tagGroupBody)
        : this.editTagGroup(tagGroupBody, isSaveClicked);
    } else {
      this._cS.markFormGroupTouched(this._fS.tagsGroupForm);
    }
  }

  // edit tag group
  editTagGroup(tagGroupBody: any, isSaveClicked: boolean = false) {
    if (!isSaveClicked) {
      this.isLoadingTagUpdate = true;
    }
    this._iS.updateTagGroup(tagGroupBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.tags = JSON.parse(JSON.stringify(response.result.tags));
        this.tagname = "";
        const updatedData = response.result;

        if (response.result.tags.length > 0) {
          this.newCreatedTag.emit({ newTag: response.result.id });
        }
        const index = this.tagGroupData.findIndex(
          (x: any) => x.id == response.result.id
        );
        this.tagGroupData[index].name = updatedData.name;
        this.tagGroupData[index].transactionCount =
          updatedData.transactionCount;
        this.tagGroupData[index].tags = updatedData.tags;
        this.tagGroupData[index].color = updatedData.color;
        this.tagGroupData = [...this.tagGroupData];
        this.isLoadingTagUpdate = false;
        this.isLoadingTag = false;
      } else {
        this.isLoadingTagUpdate = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }

  // create new group
  createNewTagGroup(tagGroupBody: any) {
    this.isLoadingTag = true;
    this._iS.addTagGroup(tagGroupBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.isTagGroupAdded = true;
        this.isEnableButton = true;
        this.doc.documentElement.style.setProperty(
          "--tag-group-color",
          this.color
        );

        this.tagGroupData?.splice(1, 0, response.result);
        this.tagGroupData = [...this.tagGroupData];
        if (this.tagGroupData?.length > 99) {
          this.getAllTags();
        }
        this.selectedTagGroupData = response.result;
        this.isLoadingTag = false;
      } else {
        this.isLoadingTag = false;
        this.isTagGroupAdded = false;
        this._cS.displayMessage(responseMessageStatus.error, response.message);
      }
    });
  }
  navigateToActivity(data: any) {
    this.browserPlatformService.openInNewTab(
      "/paybev/" +
        this.siteId +
        "/activity-detailed?tag=" +
        data.id +
        "&startDate=" +
        this.siteDetails.Date.split('T')[0]
    );
  }
  //cancel tag group modal
  handleCancel(): void {
    this.isVisibleTagGroup = false;
    this.isTagGroupAdded = false;
    this.isEnableButton = false;
    this.tagname = "";
    this.tags = this.selectedTagGroup.tags;
  }

  // show tag modal
  VisibleTag(tagGroupdata: any, data: any): void {
    this._fS.tagForm.reset();
    this.isVisibleTag = true;
    // this.getTagGroupsForDropdown();
    this.selectedTagData = data;
    this.parentTagGroupId = tagGroupdata?.id;
    if (tagGroupdata) {
      this.selectedTagGroup = tagGroupdata;
      this.selectedTagGroup.Color = tagGroupdata.color;
    }
    if (this.selectedTagData != null) {
      this.tagTitle = "Edit Tag";
      this._fS.tagForm.patchValue({
        tagName: this.selectedTagData.name,
        tagGroup: tagGroupdata.id,
      });
    } else {
      this.tagTitle = "Add Tag";
    }
  }

  //on click add of tag modal
  handleOkisVisibleTag() {
    if (this._fS.tagForm.valid) {
      const formvalue = this._fS.tagForm.value;
      const tagBody = {
        tagGroupId: formvalue.tagGroup,
        tagName: formvalue.tagName,
        tagId: this.selectedTagData == null ? "" : this.selectedTagData.id,
      };
      this.selectedTagData == null
        ? this.createNewTag(tagBody)
        : this.editTag(tagBody);
    } else {
      this._cS.markFormGroupTouched(this._fS.tagForm);
    }
  }
  //create new tag under any tag group
  createNewTag(tagBody: any) {
    this.isLoadingTag = true;
    this._iS.addTag(tagBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.isLoadingTag = false;
        const index = this.tagGroupData.findIndex(
          (x: any) => x.id == response.result.id
        );
        if (this.tagGroupData?.length > 99) {
          this.getAllTags();
        } else {
          this.tagGroupData[index].tags = response.result.tags;
        }

        this.newCreatedTag.emit({ newTag: response.result.id });
        this.handleCancelisVisibleTag();
      } else {
        this.isLoadingTag = false;
      }
    });
  }

  //edit tag under any tag group
  editTag(tagBody: any) {
    this.isLoadingTag = true;
    this._iS.updateTag(tagBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        const index = this.tagGroupData.findIndex(
          (x: any) => x.id == response.result.id
        );
        this.tagGroupData[index].tags = response.result.tags;
        if (this.parentTagGroupId != response.result.id) {
          const oldGroupIndex = this.tagGroupData.findIndex(
            (x: any) => x.id == this.parentTagGroupId
          );

          this.tagGroupData[oldGroupIndex].tags = this.tagGroupData[
            oldGroupIndex
          ].tags.filter((x: any) => x.id !== this.selectedTagData.id);
          this.tagGroupData[oldGroupIndex].tags = [
            ...this.tagGroupData[oldGroupIndex].tags,
          ];
        }
        this.isLoadingTag = false;
        this.handleCancelisVisibleTag();
      } else {
        this.isLoadingTag = false;
      }
    });
  }

  //cancel tag modal
  handleCancelisVisibleTag() {
    this.isVisibleTag = false;
  }

  //cancel delete modal
  handleCancelDelete() {
    this.deleteConfirmVisible = false;
  }

  //delete tag or tag group
  deleteData() {
    this.isDeletingTag = true;
    this.selectedData.color ? this.deleteTagGroup() : this.deleteTag();
  }

  //delete tag group
  deleteTagGroup() {
    this._iS.deleteTagGroup(this.selectedData.id).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.deleteConfirmVisible = false;
        this.isDeletingTag = false;
        this._cS.displayMessage(
          responseMessageStatus.success,
          response.message
        );
        if (this.totalRecords > 10) {
          if (this.tagGroupData.length <= 1) {
            this.pageNumber = this.pageNumber - 1;
          }
          this.getAllTags();
        } else {
          this.tagGroupData = this.tagGroupData.filter(
            (data: any) => data.id !== this.selectedData.id
          );
        }
        this._cS.tagsObserver.next("call");
      } else {
        this._cS.displayMessage(responseMessageStatus.error, response.message);
        this.deleteConfirmVisible = false;
        this.isDeletingTag = false;
      }
    });
  }

  //delete tag
  deleteTag() {
    this._iS
      .deleteTag(this.selectedTagGroupData.id, this.selectedData.id)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.deleteConfirmVisible = false;
          this.isDeletingTag = false;
          this._cS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
          const index = this.tagGroupData.findIndex(
            (x: any) => x.id == response.result.id
          );
          this.tagGroupData[index].tags = response.result.tags;
          this._cS.tagsObserver.next("call");
        } else {
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
          this.deleteConfirmVisible = false;
          this.isDeletingTag = false;
        }
      });
  }

  //showDeleteConfirm
  showDeleteConfirm(tagGroupdata: any, data: any) {
    this.deleteConfirmVisible = true;
    this.selectedData = data;
    this.selectedTagGroupData = tagGroupdata;
  }

  // to avoid expression ng-zorro error
  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  //#endregion
}
